import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { BaseView } from '@/components/base'
import { AppButton } from '@/components'
import { useSendStore } from '@/store/useSendStore'

export const SendActionButtons: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const isFiatMode = useSendStore((state) => state.isFiatMode)
  const fiatAmount = useSendStore((state) => state.fiatAmount)
  const cryptoAmount = useSendStore((state) => state.cryptoAmount)
  const setType = useSendStore((state) => state.setType)
  const shakeComponent = useSendStore((state) => state.shakeComponent)
  const isLoading = useSendStore((state) => state.isLoading)

  const adaptedAmount = isFiatMode ? fiatAmount : cryptoAmount

  // Проверяем, можно ли выполнить действие
  const canPerformAction = () => {
    const amount = parseFloat(adaptedAmount.amount)
    return amount > 0 && !isLoading
  }

  // Обработка нажатия на Request
  const handleRequest = () => {
    if (!canPerformAction()) {
      shakeComponent()
      return
    }

    setType('request')

    // Navigate to recipient selection with current parameters
    navigate('/send-request/recipient-selection', {
      state: {
        currencyValue: cryptoAmount.amount,
        currencyCode: cryptoAmount.code,
        fiatValue: fiatAmount.amount,
        fiatCode: fiatAmount.code,
        type: 'request',
      },
    })
  }

  // Обработка нажатия на Send
  const handleSend = () => {
    if (!canPerformAction()) {
      shakeComponent()
      return
    }

    setType('send')

    // Navigate to recipient selection with current parameters
    navigate('/send-request/recipient-selection', {
      state: {
        currencyValue: cryptoAmount.amount,
        currencyCode: cryptoAmount.code,
        fiatValue: fiatAmount.amount,
        fiatCode: fiatAmount.code,
        type: 'send',
      },
    })
  }

  return (
    <BaseView
      row
      align="center"
      gap={12}
      className="px-6 flex-shrink-0" // Добавил flex-shrink-0 чтобы кнопки не сжимались
      data-component="send-action-buttons"
      style={{
        zIndex: 10, // Убеждаемся, что кнопки видны поверх других элементов
        padding: 8,
        paddingLeft: 12,
        paddingRight: 12,
        borderRadius: 8,
      }}
    >
      <AppButton
        label={t('form:actions.request', 'Request')}
        onPress={handleRequest}
        isLoading={isLoading}
        isSharedSpace={true}
        type="blur"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          color: 'white',
          minHeight: '48px',
        }}
      />

      <AppButton
        label={t('form:actions.send', 'Send')}
        onPress={handleSend}
        isLoading={isLoading}
        isSharedSpace={true}
        type="blur"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          color: 'white',
          minHeight: '48px',
        }}
      />
    </BaseView>
  )
}
